<template>
  <v-card>
    <v-card-text class="d-flex flex-column">
      <span class="cross-sell-table-title">Produtos participantes da oferta</span>
      <v-text-field label="Máx. de combo por CPF" outlined hide-details readonly :value="maximumPerClient" style="width: 25%; margin-bottom: 12px" />
      <div class="d-flex flex-wrap space-between" style="gap: 24px">
        <div style="flex: 1">
          <span class="cross-sell-title">Produtos gatilho ({{ triggerProductsAmount }})</span>
          <span class="desc"
            >Aqui estão os produtos que ativam os descontos cadastrados ao lado. O consumidor pode comprar qualquer combinação de EANs dentre os listados para
            atingir a quantidade indicada no combo.</span
          >

          <v-data-table
            class="mt-4"
            :headers="triggerProductsHeader"
            :items="triggerProducts"
            :search="search"
            disable-sort
            disable-pagination
            hide-default-footer
          >
            <template v-slot:header.trigger_amount="{ header }">
              <tooltip message="Quantidade necessária do produto para ativar a oferta">
                {{ header.text }}
                <mf-icon small color="grey">info</mf-icon>
              </tooltip>
            </template>

            <!-- Removido temporariamente -->
            <!-- <template v-slot:item.status="{ item }">
              <tooltip :disabled="!disabled && !isDisabledInRules(rules.cross_sell.active)" :message="tooltipMessage">
                <mf-toggle v-model="item.active" :disabled="disabled || isDisabledInRules(rules.cross_sell.active)" class="pa-0 ml-2" hide-details />
              </tooltip>
            </template> -->
          </v-data-table>
        </div>

        <div style="flex: 1">
          <span class="cross-sell-title">Produtos com desconto ({{ targetProductsAmount }})</span>
          <span class="desc">
            Quando os critérios para ativar o desconto forem atingidos, o consumidor vai ter acesso aos produtos listados. A quantidade de produtos que ele terá
            acesso será equivalente a quantidade de produtos comprados, respeitando o mínimo para ativar o desconto e o máximo por CPF.</span
          >
          <v-data-table
            class="mt-4"
            :headers="targetProductsHeaders"
            :items="targetProducts"
            disable-sort
            disable-pagination
            disable-filtering
            hide-default-footer
          >
            <template v-slot:item.discount="{ item }">
              <span v-if="discountType === 'relative_discount_on_products'">{{ item.discount }}%</span>
              <span v-if="discountType === 'absolute_discount_on_products'">{{ locale(item.discount, 2) | localeString(2) | currency }}</span>
            </template>

            <!-- Removido temporariamente -->
            <!-- <template v-slot:item.status="{ item }">
              <tooltip :disabled="!disabled && !isDisabledInRules(rules.cross_sell.active)" :message="tooltipMessage">
                <mf-toggle v-model="item.active" :disabled="disabled || isDisabledInRules(rules.cross_sell.active)" class="pa-0 ml-2" hide-details />
              </tooltip>
            </template> -->
          </v-data-table>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Tooltip from '@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'
import { localeString } from '@/config/helpers.js'
import { getVoucherType } from '@/modules/industria/helpers/getVoucherType'
import { rules } from '@/modules/campanhas/gestao-ofertas-v2/helpers/rules.js'

export default {
  name: 'DigitalVoucherTable',
  components: {
    Tooltip,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    campaign: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isDisabledInRules: {
      type: Function,
      default: () => false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    locale: localeString,
    rules,
  }),
  computed: {
    triggerProductsHeader() {
      return [
        {
          text: 'SKU',
          align: 'start',
          filterable: true,
          width: '6%',
          value: 'sku',
        },
        {
          text: 'EAN',
          align: 'start',
          filterable: true,
          width: '12%',
          value: 'ean',
        },
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'name',
        },
        {
          text: 'Quantidade mínima',
          align: 'center',
          value: 'trigger_amount',
        },
        // {
        //   text: 'Status',
        //   value: 'status',
        //   width: '8%',
        //   sortable: false,
        // },
      ]
    },

    triggerProducts() {
      this.campaign?.cross_sell_offer_sales[0]?.trigger_products?.forEach((product) => {
        product['trigger_amount'] = this.campaign?.cross_sell_offer_sales[0]?.trigger_rules?.trigger_amount
      })
      return this.campaign?.cross_sell_offer_sales[0]?.trigger_products
    },

    targetProductsHeaders() {
      return [
        {
          text: 'SKU',
          align: 'start',
          filterable: true,
          width: '6%',
          value: 'sku',
        },
        {
          text: 'EAN',
          align: 'start',
          filterable: true,
          width: '12%',
          value: 'ean',
        },
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'name',
        },
        {
          text: 'Desconto',
          align: 'center',
          width: '16%',
          value: 'discount',
        },
        // {
        //   text: 'Status',
        //   value: 'status',
        //   width: '8%',
        //   sortable: false,
        // },
      ]
    },

    targetProducts() {
      this.campaign?.cross_sell_offer_sales[0]?.target_products?.forEach((product) => {
        product['discount'] = this.campaign?.cross_sell_offer_sales[0]?.target_rules?.discount
      })
      return this.campaign?.cross_sell_offer_sales[0]?.target_products
    },

    maximumPerClient() {
      return this.campaign?.cross_sell_offer_sales?.[0]?.trigger_rules?.maximum_per_client || 0
    },

    discountType() {
      return this.campaign?.cross_sell_offer_sales?.[0]?.target_rules?.type || ''
    },

    triggerProductsAmount() {
      return this.campaign?.cross_sell_offer_sales?.[0]?.trigger_products?.length || 0
    },

    targetProductsAmount() {
      return this.campaign?.cross_sell_offer_sales?.[0]?.target_products?.length || 0
    },
  },
  methods: { getVoucherType },
}
</script>

<style lang="scss" scoped>
.cross-sell-table-title {
  color: $cinza-d10;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
  display: block;
}
.cross-sell-title {
  color: $cinza-d10;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  display: block;
}

.desc {
  color: $cinza-0;
  font-size: 14px;
  display: block;
}

.maximum-quantity-text {
  color: $cinza-d10;
  font-size: 16px;
}

::v-deep th {
  background: $cinza-l80;
  color: $cinza-d20 !important;
  font-size: 14px;
}

::v-deep td {
  background: #f6f6f6;
}
</style>
